import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Tags from "./pages/Tags";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import CGV from "./pages/CGV";
import FAQ from "./pages/FAQ";
import Login from "./pages/Login";
import LostPassword from "./pages/LostPassword";
import ResetPassword from "./pages/ResetPassword";
import ActivateAccount from "./pages/ActivateAccount";
import Dashboard from "./pages/Dashboard";
import Folders from "./pages/Folders";
import Photos from "./pages/Photos";
import Articles from "./pages/Articles";
import Trombi from "./pages/Trombi";
import SectionTrombi from "./pages/SectionTrombi";
import Editeur from "./pages/Editeur";
import Profile from "./pages/Profile";
import ProfileEdit from "./pages/ProfileEdit";
import CSE from "./pages/CSE";
import Ambassadeurs from "./pages/Ambassadeurs";
import NotreHistoire from "./pages/NotreHistoire";
import TrackerPage from "./pages/TrackerPage";
import NotFound from "./pages/NotFound";


import YearbookLycee from "./pages/YearbookLycee";
import YearbookPrimaire from "./pages/YearbookPrimaire";
import YearbookCollege from "./pages/YearbookCollege";
import YearbookEtudesSup from "./pages/YearbookEtudesSup";
import YearbookImpression from "./pages/YearbookImpression";
import Entreprise from "./pages/Entreprise";
import PublicBdcPage from "./pages/PublicBdcPage";

import BackofficeDashboard from "./pages/backoffice/BackofficeDashboard";
import ClientsPage from "./pages/backoffice/ClientsPage";
import EntreprisesPage from "./pages/backoffice/EntreprisesPage";
import SatisfactionSurveysPage from "./pages/backoffice/SatisfactionSurveysPage";
import ComptesPage from "./pages/backoffice/ComptesPage";
import IndesignInstancesPage from "./pages/backoffice/IndesignInstancesPage";
import PlanningDesignPage from "./pages/backoffice/PlanningDesignPage";
import PlanningV2Page from "./pages/backoffice/PlanningV2Page";
import PacksPage from "./pages/backoffice/PacksPage";
import BlogsPage from "./pages/backoffice/BlogsPage";
import BlogEditPage from "./pages/backoffice/BlogEditPage";
import EbookPage from "./pages/backoffice/EbookPage";
import LiseusesPage from "./pages/backoffice/LiseusesPage";
import TasksPage from "./pages/backoffice/TasksPage";
import UpsellsPage from "./pages/backoffice/UpsellsPage";
import PrinterStatsPage from "./pages/backoffice/PrinterStatsPage";
import PrinterProductionPage from "./pages/backoffice/PrinterProductionPage";
import PrinterComparatifPage from "./pages/backoffice/PrinterComparatifPage";
import ImpressionsPage from "./pages/backoffice/ImpressionsPage";
import BdcEditorPage from "./pages/backoffice/BdcEditorPage";
import BdcListPage from "./pages/backoffice/BdcListPage";
import PlanningBusinessPage from "./pages/backoffice/PlanningBusinessPage";
import FichePage from "./pages/backoffice/FichePage";
import FicheEditPage from "./pages/backoffice/FicheEditPage";
import PaymentsPage from "./pages/backoffice/PaymentsPage";
import GrillePage from "./pages/backoffice/GrillePage";
import DddPage from "./pages/backoffice/DddPage";
import RecapUpsellPage from "./pages/backoffice/RecapUpsellPage";
import ProspectionPage from "./pages/backoffice/ProspectionPage";
import RenouvellementPage from "./pages/backoffice/RenouvellementPage";
import NotificationsPage from "./pages/backoffice/NotificationsPage";
import TrombiTemplatesPage from "./pages/backoffice/TrombiTemplatesPage";
import IndexTrombiTemplates from "./pages/design/IndexTrombiTemplates";
import StickersPage from "./pages/backoffice/StickersPage";
import FondsPage from "./pages/backoffice/FondsPage";
import TdfPage from "./pages/backoffice/TdfPage";
import TdfZonesPage from "./pages/backoffice/TdfZonesPage";
import RoadmapPage from "./pages/backoffice/RoadmapPage";
import RdvTerrainPage from "./pages/backoffice/RdvTerrainPage";

import IndexEditor from "./pages/IndexEditor";
import IndexRelecture from "./pages/IndexRelecture";
import IndexSurvey from "./pages/IndexSurvey";
import IndexValidation from "./pages/IndexValidation";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
  <QueryClientProvider client={queryClient}>
    <TooltipProvider delayDuration={200}>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
		  <Route path="/test" element={<Index />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/article/:id" element={<BlogPost />} />
          <Route path="/tags/:id" element={<Tags />} />
          <Route path="/terms" element={<MentionsLegales />} />
          <Route path="/politique_de_confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/login" element={<Login />} />
          <Route path="/lost_password" element={<LostPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/events" element={<Folders />} />
          <Route path="/events/:id/pictures" element={<Photos />} />
          <Route path="/events/:id/articles" element={<Articles />} />
          <Route path="/trombi" element={<Trombi />} />
          <Route path="/users/:id/section_trombi/" element={<SectionTrombi />} />
          <Route path="/editeur" element={<Editeur />} />
          <Route path="/users/:id" element={<Profile />} />
          <Route path="/users/:id/edit" element={<ProfileEdit />} />
          <Route path="/password_reset/:id" element={<ResetPassword />} />
          <Route path="/activation/:id" element={<ActivateAccount />} />
          <Route path="/cse" element={<CSE />} />
          <Route path="/entreprise" element={<Entreprise />} />
          <Route path="/ambassadeurs" element={<Ambassadeurs />} />
          <Route path="/notre-histoire" element={<NotreHistoire />} />
          <Route path="/le-yearbook-lycee" element={<YearbookLycee />} />
          <Route path="/le-yearbook-primaire" element={<YearbookPrimaire />} />
          <Route path="/le-yearbook-college" element={<YearbookCollege />} />
          <Route path="/le-yearbook-etudes-sup" element={<YearbookEtudesSup />} />
          <Route path="/yearbook-petite-impression" element={<YearbookImpression />} />
          <Route path="/editor" element={<IndexEditor />} />
          <Route path="/purchase_orders/:token" element={<PublicBdcPage />} />
          <Route path="/trackers/:id" element={<TrackerPage />} />
          
          {/* Backoffice */}
          <Route path="/bo" element={<BackofficeDashboard />} />
          <Route path="/crm_entreprises" element={<EntreprisesPage />} />
          <Route path="/social_networks" element={<ClientsPage />} />
          <Route path="/planning_designv2" element={<PlanningDesignPage />} />
          import PacksPage from "./pages/backoffice/PacksPage";
          <Route path="/satisfaction_surveys" element={<SatisfactionSurveysPage />} />
          <Route path="/users" element={<ComptesPage />} />
          <Route path="/indesign_instances" element={<IndesignInstancesPage />} />
          <Route path="/packs" element={<PacksPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/new" element={<BlogEditPage />} />
          <Route path="/blogs/:id/edit" element={<BlogEditPage />} />
          <Route path="/ebook" element={<EbookPage />} />
          <Route path="/liseuses" element={<LiseusesPage />} />
          <Route path="/planningv2" element={<PlanningV2Page />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/upsellsv2" element={<UpsellsPage />} />
          <Route path="/printer_stats" element={<PrinterStatsPage />} />
          <Route path="/printer_production" element={<PrinterProductionPage />} />
          <Route path="/printer_comparatif" element={<PrinterComparatifPage />} />
          <Route path="/impressions" element={<ImpressionsPage />} />
          <Route path="/bdc_editor" element={<BdcEditorPage />} />
          <Route path="/bdc_editor/:id" element={<BdcEditorPage />} />
          <Route path="/purchase_orders" element={<BdcListPage />} />
          <Route path="/planning_business" element={<PlanningBusinessPage />} />
          <Route path="/social_networks/new_fiche" element={<FicheEditPage />} />
          <Route path="/social_networks/:id" element={<FichePage />} />
          <Route path="/social_networks/:id/fiche_edit" element={<FicheEditPage />} />
          <Route path="/payments/indexv2" element={<PaymentsPage />} />
          <Route path="/grille" element={<GrillePage />} />
          <Route path="/ddd" element={<DddPage />} />
          <Route path="/recap_upsells" element={<RecapUpsellPage />} />
          <Route path="/prospectionv2" element={<ProspectionPage />} />
          <Route path="/renouvellementv2" element={<RenouvellementPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/trombi_template" element={<IndexTrombiTemplates />} />
          <Route path="/trombi_templates" element={<TrombiTemplatesPage />} />
          <Route path="/stickers" element={<StickersPage />} />
          <Route path="/fonds" element={<FondsPage />} />
          <Route path="/tdf" element={<TdfZonesPage />} />
          <Route path="/tdf/:id" element={<TdfPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/rdv_terrain" element={<RdvTerrainPage />} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="/relecture" element={<IndexRelecture />} />
          <Route path="/surveys" element={<IndexSurvey />} />
          <Route path="/validation" element={<IndexValidation />} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  </HelmetProvider>
);

export default App;
